<script>
  import { onMount, getContext, onDestroy } from 'svelte';
  import { client } from 'root/api/index.js';
  import ProfileImg from './ProfileImage.svelte';
  import Loader from './Loader.svelte';
  import InfiniteScroll from './DataTable/InfiniteScroll.svelte';
  import { displayTimeAgo } from 'components/Helper.js';
  const showDialog = getContext('showDialog');
  export let id = 0;
  let pageSize = 20;
  let pageNumber = 1;
  let totalPages = 0;
  let taskLogData = [];
  let isPaginationLoading = false;
  export const show = (taskId) => {
    pageNumber = 1;
    totalPages = 0;
    taskLogData = [];
    id = taskId;
    getHistoryList();
  };
  const getHistoryList = () => {
    if (id == 0) {
      return;
    }
    isPaginationLoading = true;
    client
      .taskHistoryList(pageSize, pageNumber, { taskId: id })
      .then((response) => {
        isPaginationLoading = false;
        taskLogData = taskLogData.concat(response.data.payload);
        totalPages = response.data.pagination.totalPage;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
</script>

<div class="page-content p-3">
  {#if taskLogData.length <= 0 && !isPaginationLoading}
    <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
      <svg
        width="50"
        height="50"
        viewBox="0 0 100 100"
        fill="#C8D6E7"
        ><path
          d="M44.5 28.0008H50V50.0006H44.5V28.0008ZM28 39.0007H6V17.001H11.5V28.7743C13.4193 25.2509 15.7539 22.0855 18.5039 19.2783C21.2539 16.471 24.2904 14.0934 27.6133 12.1456C30.9362 10.1977 34.5026 8.67945 38.3125 7.59093C42.1224 6.5024 46.0182 5.97246 50 6.0011C54.0391 6.0011 57.9349 6.51672 61.6875 7.54796C65.4401 8.57919 68.9492 10.0544 72.2148 11.9737C75.4805 13.8929 78.4453 16.1846 81.1094 18.8486C83.7734 21.5126 86.0651 24.4918 87.9844 27.786C89.9036 31.0802 91.3789 34.5893 92.4102 38.3132C93.4414 42.0371 93.9714 45.9329 94 50.0006H88.5C88.5 46.4772 88.0417 43.0827 87.125 39.8171C86.2083 36.5515 84.9193 33.4864 83.2578 30.6219C81.5964 27.7573 79.5768 25.1506 77.1992 22.8017C74.8216 20.4527 72.2292 18.4476 69.4219 16.7861C66.6146 15.1247 63.5495 13.8213 60.2266 12.876C56.9036 11.9307 53.4948 11.4724 50 11.501C46.3047 11.501 42.7096 12.0167 39.2148 13.0479C35.7201 14.0791 32.4688 15.5544 29.4609 17.4736C26.4531 19.3929 23.7174 21.6988 21.2539 24.3915C18.7904 27.0842 16.7852 30.1206 15.2383 33.5008H28V39.0007ZM50 55.5005H94V61.0004H50V55.5005ZM50 72.0003H94V77.5002H50V72.0003ZM50 88.5001H94V94H50V88.5001ZM12.918 60.27C13.9492 63.9652 15.4531 67.3884 17.4297 70.5394C19.4062 73.6904 21.7839 76.469 24.5625 78.8752C27.3411 81.2814 30.4062 83.2866 33.7578 84.8907C37.1094 86.4949 40.6901 87.5548 44.5 88.0704V93.6563C40.0885 93.0547 35.9062 91.8659 31.9531 90.0899C28 88.3139 24.4193 86.0509 21.2109 83.3009C18.0026 80.551 15.2383 77.3427 12.918 73.676C10.5977 70.0094 8.83594 66.0277 7.63281 61.7309L12.918 60.27Z"
          fill=""
        /></svg
      >
      <span class="color-lead font-size-18 mt-2 d-block"
        >There is no task history log available</span
      >
    </div>
  {/if}
  <div class="task-log">
    <ul class="position-relative">
      {#each taskLogData as itemData, itemkey}
        <li class="position-relative">
          <div class="d-flex flex-row">
            <div
              class="user-profile-img d-flex me-3"
              style="width:40px;height:40px;"
            >
              <ProfileImg
                size={40}
                photoUrl={itemData.user.photoUrl}
                firstName={itemData.user.firstName}
                lastName={itemData.user.lastName}
              />
            </div>
            <div class="w-100">
              <div class="d-flex flex-row justify-content-between">
                <strong class="d-block font-weight-500"
                  >{itemData.user.firstName}
                  {itemData.user.lastName}</strong
                >
                <small class="text-muted">
                  <img
                    alt=""
                    class="me-1 icon-14"
                    src="/images/clock.svg"
                  />
                  <span>{itemData.timeAgoStr}</span></small
                >
              </div>
              <span class="d-block">{itemData.notes}.</span>
              <span class="d-block"
                >{itemData.message && itemData.message.trim() == ''
                  ? ''
                  : 'Notes: '}{itemData.message}</span
              >
            </div>
          </div>
        </li>
      {/each}
    </ul>
  </div>
  <InfiniteScroll
    threshold={300}
    hasMore={pageNumber < totalPages}
    isLoading={isPaginationLoading}
    on:loadMore={() => {
      pageNumber = pageNumber + 1;
      getHistoryList();
    }}
  >
    <div
      class="scroll-spinner-container d-flex justify-content-center
			  align-items-center"
    >
      <Loader Style="loader-block" />
    </div>
  </InfiniteScroll>
</div>

<style lang="scss">
</style>
